/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CenterChildStatDto } from '../models/center-child-stat-dto';
import { centerStatControllerGetCenterChildStat } from '../fn/center-stat/center-stat-controller-get-center-child-stat';
import { CenterStatControllerGetCenterChildStat$Params } from '../fn/center-stat/center-stat-controller-get-center-child-stat';
import { centerStatControllerGetCounselingAndTreatmentStat } from '../fn/center-stat/center-stat-controller-get-counseling-and-treatment-stat';
import { CenterStatControllerGetCounselingAndTreatmentStat$Params } from '../fn/center-stat/center-stat-controller-get-counseling-and-treatment-stat';
import { centerStatControllerGetCounselingStat } from '../fn/center-stat/center-stat-controller-get-counseling-stat';
import { CenterStatControllerGetCounselingStat$Params } from '../fn/center-stat/center-stat-controller-get-counseling-stat';
import { centerStatControllerGetSalaryStat } from '../fn/center-stat/center-stat-controller-get-salary-stat';
import { CenterStatControllerGetSalaryStat$Params } from '../fn/center-stat/center-stat-controller-get-salary-stat';
import { centerStatControllerGetSalesStat } from '../fn/center-stat/center-stat-controller-get-sales-stat';
import { CenterStatControllerGetSalesStat$Params } from '../fn/center-stat/center-stat-controller-get-sales-stat';
import { centerStatControllerGetScheduleStat } from '../fn/center-stat/center-stat-controller-get-schedule-stat';
import { CenterStatControllerGetScheduleStat$Params } from '../fn/center-stat/center-stat-controller-get-schedule-stat';
import { CenterStatSalaryDto } from '../models/center-stat-salary-dto';
import { CenterStatSalesDto } from '../models/center-stat-sales-dto';
import { CenterStatScheduleDto } from '../models/center-stat-schedule-dto';

@Injectable({ providedIn: 'root' })
export class CenterStatService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerStatControllerGetSalesStat()` */
  static readonly CenterStatControllerGetSalesStatPath = '/api/center-stat/sales';

  /**
   * 센터 매출 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetSalesStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetSalesStat$Response(params: CenterStatControllerGetSalesStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterStatSalesDto>>> {
    return centerStatControllerGetSalesStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 매출 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetSalesStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetSalesStat(params: CenterStatControllerGetSalesStat$Params, context?: HttpContext): Observable<Array<CenterStatSalesDto>> {
    return this.centerStatControllerGetSalesStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterStatSalesDto>>): Array<CenterStatSalesDto> => r.body)
    );
  }

  /** Path part for operation `centerStatControllerGetSalaryStat()` */
  static readonly CenterStatControllerGetSalaryStatPath = '/api/center-stat/salary';

  /**
   * 센터 급여 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetSalaryStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetSalaryStat$Response(params: CenterStatControllerGetSalaryStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterStatSalaryDto>>> {
    return centerStatControllerGetSalaryStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetSalaryStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetSalaryStat(params: CenterStatControllerGetSalaryStat$Params, context?: HttpContext): Observable<Array<CenterStatSalaryDto>> {
    return this.centerStatControllerGetSalaryStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterStatSalaryDto>>): Array<CenterStatSalaryDto> => r.body)
    );
  }

  /** Path part for operation `centerStatControllerGetScheduleStat()` */
  static readonly CenterStatControllerGetScheduleStatPath = '/api/center-stat/schedule';

  /**
   * 센터 회기 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetScheduleStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetScheduleStat$Response(params: CenterStatControllerGetScheduleStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
    return centerStatControllerGetScheduleStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 회기 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetScheduleStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetScheduleStat(params: CenterStatControllerGetScheduleStat$Params, context?: HttpContext): Observable<CenterStatScheduleDto> {
    return this.centerStatControllerGetScheduleStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterStatScheduleDto>): CenterStatScheduleDto => r.body)
    );
  }

  /** Path part for operation `centerStatControllerGetCounselingStat()` */
  static readonly CenterStatControllerGetCounselingStatPath = '/api/center-stat/counseling';

  /**
   * 상담 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetCounselingStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCounselingStat$Response(params: CenterStatControllerGetCounselingStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
    return centerStatControllerGetCounselingStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetCounselingStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCounselingStat(params: CenterStatControllerGetCounselingStat$Params, context?: HttpContext): Observable<CenterStatScheduleDto> {
    return this.centerStatControllerGetCounselingStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterStatScheduleDto>): CenterStatScheduleDto => r.body)
    );
  }

  /** Path part for operation `centerStatControllerGetCounselingAndTreatmentStat()` */
  static readonly CenterStatControllerGetCounselingAndTreatmentStatPath = '/api/center-stat/all-schedule';

  /**
   * 센터 치료/상담 일정 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetCounselingAndTreatmentStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCounselingAndTreatmentStat$Response(params: CenterStatControllerGetCounselingAndTreatmentStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
    return centerStatControllerGetCounselingAndTreatmentStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 치료/상담 일정 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetCounselingAndTreatmentStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCounselingAndTreatmentStat(params: CenterStatControllerGetCounselingAndTreatmentStat$Params, context?: HttpContext): Observable<CenterStatScheduleDto> {
    return this.centerStatControllerGetCounselingAndTreatmentStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterStatScheduleDto>): CenterStatScheduleDto => r.body)
    );
  }

  /** Path part for operation `centerStatControllerGetCenterChildStat()` */
  static readonly CenterStatControllerGetCenterChildStatPath = '/api/center-stat/child';

  /**
   * 센터 아동 상태 통계.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerStatControllerGetCenterChildStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCenterChildStat$Response(params: CenterStatControllerGetCenterChildStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterChildStatDto>> {
    return centerStatControllerGetCenterChildStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 아동 상태 통계.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerStatControllerGetCenterChildStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerStatControllerGetCenterChildStat(params: CenterStatControllerGetCenterChildStat$Params, context?: HttpContext): Observable<CenterChildStatDto> {
    return this.centerStatControllerGetCenterChildStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterChildStatDto>): CenterChildStatDto => r.body)
    );
  }

}
